<template>
  <div>
    <div class="tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="房源信息" name="site"></el-tab-pane>
        <el-tab-pane label="房源描述" name="describe"></el-tab-pane>
        <el-tab-pane label="配套设施" name="facility"></el-tab-pane>
        <el-tab-pane label="真实照片" name="photograph"></el-tab-pane>
        <el-tab-pane label="价格规则" name="price"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- 地址模块 -->
    <div class="information_title tabs_bottom" id="site">房源地址</div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">房源位于：</div>
        <div class="information_site_right">
          {{ hourseInfo.address }}{{ hourseInfo.location }}
        </div>
      </div>
    </div>
    <div class="information_title">房源基本情况</div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">房源类型：</div>
        <el-select v-model="this.houseTypeList" placeholder="请选择">
          <el-option
            disabled
            v-for="(item, index) in houseType"
            :key="index"
            :label="item.vMenuName"
            :value="item.iConfigId"
          ></el-option>
        </el-select>
      </div>
    </div>
    <!-- 出租类型 -->
    <div class="information_siteBox" v-if="hourseInfo.houseInfoSon.iRenderType">
      <div class="information_site">
        <div class="information_site_left">出租类型：</div>
        <div class="radio_boxs">
          <div class="radio" v-if="hourseInfo.houseInfoSon.iRenderType == 1">
            <div
              class="radio_left_"
              v-if="hourseInfo.houseInfoSon.iRenderType == 1"
            >
              <div class="ischeck"></div>
            </div>
            <div class="radio_left" v-else></div>
            <div class="radio_right">
              <div class="radio_right_top">
                整套出租
              </div>
              <div class="radio_right_bottom">房客独享整套房屋</div>
            </div>
          </div>
          <div class="radio " v-if="hourseInfo.houseInfoSon.iRenderType == 2">
            <div
              class="radio_left_"
              v-if="hourseInfo.houseInfoSon.iRenderType == 2"
            >
              <div class="ischeck"></div>
            </div>
            <div class="radio_left" v-else></div>
            <div class="radio_right">
              <div class="radio_right_top">
                独立单间
              </div>
              <div class="radio_right_bottom">
                房客拥有一个独立的房间，但部分空间与他人分享
              </div>
            </div>
          </div>
          <div class="radio" v-if="hourseInfo.houseInfoSon.iRenderType == 3">
            <div
              class="radio_left_"
              v-if="hourseInfo.houseInfoSon.iRenderType == 3"
            >
              <div class="ischeck"></div>
            </div>
            <div class="radio_left" v-else></div>
            <div class="radio_right">
              <div class="radio_right_top">
                合住房间
              </div>
              <div class="radio_right_bottom">
                房客与他人共住一个房间，没有独立的卧室（如：床位、沙发等）
              </div>
            </div>
          </div>
          <div
            class="radio_bottom"
            v-if="
              hourseInfo.houseInfoSon.iRenderType == 2 ||
                hourseInfo.houseInfoSon.iRenderType == 3
            "
          >
            <div class="radio_bottom_text">房东是否与房客同住</div>

            <div class="radio_yes">
              <div
                class="radio_yes_left_s"
                v-if="hourseInfo.houseInfoSon.iStayWithLoad == 1"
              >
                <div class="radio_box"></div>
              </div>
              <div class="radio_yes_left" v-else></div>
              <div class="radio_yes_right">是</div>
            </div>
            <div class="radio_no">
              <div
                class="radio_no_left_s"
                v-if="hourseInfo.houseInfoSon.iStayWithLoad == 2"
              >
                <div class="radio_box"></div>
              </div>
              <div class="radio_no_left" v-else></div>
              <div class="radio_no_right">否</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 房屋户型 -->
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">房屋户型：</div>
        <div class="radio_boxs">
          <el-input
            readonly
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model.number="hourseInfo.roomNumber"
            placeholder="请输入内容"
          ></el-input>
          室
          <el-input
            readonly
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model.number="hourseInfo.hallNumber"
            placeholder="请输入内容"
          ></el-input>
          厅
          <el-input
            readonly
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model.number="hourseInfo.bathroomNumber"
            placeholder="请输入内容"
          ></el-input>
          卫
          <el-input
            readonly
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model.number="hourseInfo.kitchenNumber"
            placeholder="请输入内容"
          ></el-input>
          厨
          <el-input
            readonly
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model.number="hourseInfo.balconyNumber"
            placeholder="请输入内容"
          ></el-input>
          阳台
        </div>
      </div>
    </div>
    <!-- 出租面积 -->
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">出租面积：</div>
        <div class="radio_boxs">
          <el-input
            readonly
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model.number="hourseInfo.houseInfoSon.vHourseArea"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <span>平方米</span>
      </div>
    </div>
    <!-- 卫生间类型 -->
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">卫生间类型：</div>
        <div class="radio_boxs">
          <div class="radio" v-if="hourseInfo.houseInfoSon.iToiletType == 1">
            <div
              class="radio_left_"
              v-if="hourseInfo.houseInfoSon.iToiletType == 1"
            >
              <div class="ischeck"></div>
            </div>
            <div class="radio_left" v-else></div>
            <div class="radio_right">
              <div class="radio_right_top">
                独立卫生间
              </div>
              <div class="radio_right_bottom">房客独享的卫生间</div>
            </div>
          </div>
          <div class="radio " v-if="hourseInfo.houseInfoSon.iToiletType == 2">
            <div
              class="radio_left_"
              v-if="hourseInfo.houseInfoSon.iToiletType == 2"
            >
              <div class="ischeck"></div>
            </div>
            <div class="radio_left" v-else></div>
            <div class="radio_right">
              <div class="radio_right_top">
                公共卫生间
              </div>
              <div class="radio_right_bottom">
                可能与他人分享的卫生间
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 床铺信息 -->
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">床铺信息：</div>
        <div class="radio_boxs">
          <div
            class="acreage"
            v-for="(item, index) in hourseInfo.houseBedInfo"
            :key="index"
          >
            <el-cascader
              disabled
              :options="options"
              v-model="item.vBedStyles"
              placeholder="选择床型和尺寸"
            ></el-cascader>
            <el-input
              readonly
              oninput="value=value.replace(/[^\d.]/g,'')"
              v-model.number="item.iBedNumber"
              placeholder="请输入内容"
            ></el-input>
            张
          </div>
        </div>
      </div>
    </div>
    <!-- 宜居人数 -->
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">宜居人数：</div>
        <div class="radio_boxs">
          <el-input
            readonly
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model.number="hourseInfo.houseInfoSon.iLiveNum"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <span>人</span>
      </div>
    </div>
    <!-- 同类房源 -->
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">同类房源：</div>
        <div class="radio_boxs">
          <el-input
            readonly
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model.number="hourseInfo.houseInfoSon.iSameHourTotal"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <span>间</span>
      </div>
    </div>
    <!-- 房源描述 -->
    <div class="information_title" id="describe">房源描述</div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">房源标题：</div>
        <div class="radio_boxs">
          <el-input
            readonly
            class="input_title"
            type="textarea"
            maxlength="50"
            resize="none"
            placeholder="请输入内容"
            v-model="hourseInfo.vHousTitle"
          >
          </el-input>
        </div>
      </div>
    </div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">房源亮点：</div>
        <div class="radio_boxs">
          <el-input
            readonly
            maxlength="2000"
            type="textarea"
            resize="none"
            placeholder="请输入内容"
            v-model="hourseInfo.houseInfoSon.vHourHighlight"
          >
          </el-input>
        </div>
      </div>
    </div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">周边情况：</div>
        <div class="radio_boxs">
          <el-input
            readonly
            maxlength="2000"
            type="textarea"
            resize="none"
            placeholder="请输入内容"
            v-model="hourseInfo.houseInfoSon.vSurroundInfo"
          >
          </el-input>
        </div>
      </div>
    </div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">房东留言：</div>
        <div class="radio_boxs">
          <el-input
            readonly
            maxlength="2000"
            type="textarea"
            resize="none"
            placeholder="请输入内容"
            v-model="hourseInfo.houseInfoSon.vHourloadMess"
          >
          </el-input>
        </div>
      </div>
    </div>
    <!-- 配套设施 -->
    <div class="information_title" id="facility">配套设施</div>
    <div class="information_siteBox">
      <div class="information_site">
        <div
          class="facility_list"
          v-for="(item, index) in serviceList.children"
          :key="index"
        >
          <div class="facility_list_left">
            <div class="img">
              <!-- <img :src="item.meta.icon" /> -->
              <div class="img_text">{{ item.label }}</div>
            </div>
          </div>
          <div class="facility_list_right">
            <div
              class="facility_list_rightList_box"
              v-for="(item2, index2) in item.children"
              :key="index2"
            >
              <div class="facility_list_rightList" v-if="item2.hidden == '1'">
                <div class="rightList_left">
                  <!-- v-if="demand.indexOf(item2.value.toString()) !== -1" -->
                  <img
                    v-if="item2.component == '1'"
                    src="https://test.youjiaminsu.cn:333/avatar/2021/06/04/20210604112843.png"
                  />
                  <img
                    v-else
                    src="https://test.youjiaminsu.cn:333/avatar/2021/06/04/20210604112851.png"
                    alt=""
                  />
                </div>
                <div class="rightList_right">{{ item2.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="information_title">入住须知</div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="notice" v-for="(item, index) in CheckInNotes" :key="index">
          <div class="notice_left">{{ item.label }}</div>
          <div class="notice_right">
            <img
              v-if="demand&&demand.indexOf(item.value.toString()) !== -1"
              src="https://test.youjiaminsu.cn:333/avatar/2021/06/04/20210604112843.png"
            />
            <img
              v-else
              src="https://test.youjiaminsu.cn:333/avatar/2021/06/04/20210604112851.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="information_title">其他注意事项</div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="radio_boxs">
          <el-input
            readonly
            type="textarea"
            resize="none"
            placeholder="请输入内容"
            v-model="hourseInfo.houseInfoSon.vOtherName"
          >
          </el-input>
        </div>
      </div>
    </div>
    <!-- 房源照片 -->
    <div class="information_title" id="photograph">房源照片</div>
    <div class="picture_box" v-if="hourseInfo.houseInfoSon.vCoverPics">
      <div class="picture_box_top">
        封面：
      </div>
      <div class="picture_box_bottom">
        <div
          class="picture_upload"
          v-for="(item, index) in hourseInfo.houseInfoSon.vCoverPics"
          :key="index"
          @click="getImg(item)"
        >
          <el-image
            style="width: 120px; height: 120px"
            :src="item"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
      </div>
    </div>
    <div class="picture_box" v-if="hourseInfo.houseInfoSon.vBedrooms">
      <div class="picture_box_top">
        卧室：
      </div>
      <div class="picture_box_bottom">
        <div
          class="picture_upload"
          v-for="(item, index) in hourseInfo.houseInfoSon.vBedrooms"
          :key="index"
          @click="getImg(item)"
        >
          <el-image
            style="width: 120px; height: 120px"
            :src="item"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
      </div>
    </div>

    <div class="picture_box" v-if="hourseInfo.houseInfoSon.vSaloonPics">
      <div class="picture_box_top">
        客厅：
      </div>
      <div class="picture_box_bottom">
        <div
          class="picture_upload"
          v-for="(item, index) in hourseInfo.houseInfoSon.vSaloonPics"
          :key="index"
          @click="getImg(item)"
        >
          <el-image
            style="width: 120px; height: 120px"
            :src="item"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
      </div>
    </div>
    <div class="picture_box" v-if="hourseInfo.houseInfoSon.vToiletPics">
      <div class="picture_box_top">
        卫生间：
      </div>
      <div class="picture_box_bottom">
        <div
          class="picture_upload"
          v-for="(item, index) in hourseInfo.houseInfoSon.vToiletPics"
          :key="index"
          @click="getImg(item)"
        >
          <el-image
            style="width: 120px; height: 120px"
            :src="item"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
      </div>
    </div>
    <div class="picture_box" v-if="hourseInfo.houseInfoSon.vKitchenPics">
      <div class="picture_box_top">
        厨房：
      </div>
      <div class="picture_box_bottom">
        <div
          class="picture_upload"
          v-for="(item, index) in hourseInfo.houseInfoSon.vKitchenPics"
          :key="index"
          @click="getImg(item)"
        >
          <el-image
            style="width: 120px; height: 120px"
            :src="item"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
      </div>
    </div>
    <div class="picture_box" v-if="hourseInfo.houseInfoSon.vGalleryPics">
      <div class="picture_box_top">
        阳台：
      </div>
      <div class="picture_box_bottom">
        <div
          class="picture_upload"
          v-for="(item, index) in hourseInfo.houseInfoSon.vGalleryPics"
          :key="index"
          @click="getImg(item)"
        >
          <el-image
            style="width: 120px; height: 120px"
            :src="item"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
      </div>
    </div>
    <div class="picture_box" v-if="hourseInfo.houseInfoSon.vOtherPics">
      <div class="picture_box_top">
        其他：
      </div>
      <div class="picture_box_bottom">
        <div
          class="picture_upload"
          v-for="(item, index) in hourseInfo.houseInfoSon.vOtherPics"
          :key="index"
          @click="getImg(item)"
        >
          <el-image
            style="width: 120px; height: 120px"
            :src="item"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
      </div>
    </div>
    <!-- 价格规则 -->
    <div class="information_title" id="price">价格规则</div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">是否设置节假日价格：</div>
        <div class="radio_boxs">
          <div
            class="radio_yes"
            v-if="hourseInfo.houseFavour.iSettingFestival == 1"
          >
            <div
              class="radio_yes_left_s"
              v-if="hourseInfo.houseFavour.iSettingFestival == 1"
            >
              <div class="radio_box"></div>
            </div>
            <div class="radio_yes_left" v-else></div>
            <div class="radio_yes_right">是</div>
          </div>
          <div
            class="radio_yes"
            v-if="hourseInfo.houseFavour.iSettingFestival == 0"
          >
            <div
              class="radio_yes_left_s"
              v-if="hourseInfo.houseFavour.iSettingFestival == 0"
            >
              <div class="radio_box"></div>
            </div>
            <div class="radio_yes_left" v-else></div>
            <div class="radio_yes_right">否</div>
          </div>
          <!-- <div class="radio_no" @click="ischeck = 2">
            <div class="radio_no_left_s" v-if="ischeck == 2">
              <div class="radio_box"></div>
            </div>
            <div class="radio_no_left" v-else></div>
            <div class="radio_no_right">否</div>
          </div> -->
          <div class="radio_text">周五、周六及法定假日、情人节、圣诞节等</div>
        </div>
      </div>
    </div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">售卖价格：</div>
        <div class="radio_boxs">
          <div class="form_item">
            <div class="form_item_title">
              周日-周四价格
            </div>
            <div
              class="form_item_title"
              v-if="hourseInfo.houseFavour.iSettingFestival == 1"
            >
              周末价格
            </div>
            <div
              class="form_item_title"
              v-if="hourseInfo.houseFavour.iSettingFestival == 1"
            >
              节假日价格
            </div>
          </div>
          <el-input
            readonly
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model="hourseInfo.houseFavour.mDailyPrice"
            placeholder="请输入内容"
          ></el-input
          ><span>/晚</span>
          <el-input
            readonly
            v-if="hourseInfo.houseFavour.iSettingFestival == 1"
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model="hourseInfo.houseFavour.mWeekEndPrice"
            placeholder="请输入内容"
          ></el-input
          ><span v-if="hourseInfo.houseFavour.iSettingFestival == 1">/晚</span>
          <el-input
            readonly
            v-if="hourseInfo.houseFavour.iSettingFestival == 1"
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model="hourseInfo.houseFavour.mFestivePrice"
            placeholder="请输入内容"
          ></el-input
          ><span v-if="hourseInfo.houseFavour.iSettingFestival == 1">/晚</span>
        </div>
      </div>
    </div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">押金：</div>
        <div class="radio_boxs">
          <div class="iDepositRule">
            <div
              class="radio_no"
              v-if="hourseInfo.houseFavour.iDepositRule == 0"
            >
              <div
                class="radio_no_left_s"
                v-if="hourseInfo.houseFavour.iDepositRule == 0"
              >
                <div class="radio_box"></div>
              </div>
              <div class="radio_no_left" v-else></div>
              <div class="radio_no_right">不收取押金</div>
            </div>
            <div
              class="radio_no"
              v-if="hourseInfo.houseFavour.iDepositRule == 1"
            >
              <div
                class="radio_no_left_s"
                v-if="hourseInfo.houseFavour.iDepositRule == 1"
              >
                <div class="radio_box"></div>
              </div>
              <div class="radio_no_left" v-else></div>
              <div class="radio_no_right">平台代收押金</div>
            </div>
            <div
              class="radio_no"
              v-if="hourseInfo.houseFavour.iDepositRule == 2"
            >
              <div
                class="radio_no_left_s"
                v-if="hourseInfo.houseFavour.iDepositRule == 2"
              >
                <div class="radio_box"></div>
              </div>
              <div class="radio_no_left" v-else></div>
              <div class="radio_no_right">房东线下收取押金</div>
            </div>
          </div>
          <div
            class="iDepositRule_input"
            v-if="
              hourseInfo.houseFavour.iDepositRule == 2 ||
                hourseInfo.houseFavour.iDepositRule == 1
            "
          >
            <el-input
              oninput="value=value.replace(/[^\d.]/g,'')"
              v-model="hourseInfo.houseFavour.mDepositMoney"
              placeholder="请输入内容"
            ></el-input
            >元
          </div>
        </div>
      </div>
    </div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">可住人数：</div>
        <div class="radio_boxs">
          <el-input
            readonly
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model="hourseInfo.houseFavour.iResidentNum"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <span>人</span>
      </div>
    </div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">是否允许加客：</div>
        <div class="radio_boxs">
          <div class="radio_yes">
            <div
              class="radio_yes_left_s"
              v-if="hourseInfo.houseFavour.iCusPlus == 0"
            >
              <div class="radio_box"></div>
            </div>
            <div class="radio_yes_left" v-else></div>
            <div class="radio_yes_right">否</div>
          </div>
          <div class="radio_yes">
            <div
              class="radio_yes_left_s"
              v-if="hourseInfo.houseFavour.iCusPlus == 1"
            >
              <div class="radio_box"></div>
            </div>
            <div class="radio_yes_left" v-else></div>
            <div class="radio_yes_right">是</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="information_siteBox"
      v-if="hourseInfo.houseFavour.iCusPlus == 1"
    >
      <div class="information_site">
        <div class="information_site_left">最多可加人数：</div>
        <div class="radio_boxs">
          <el-input
            readonly
            v-model="hourseInfo.houseFavour.iCusPlusNum"
            placeholder="请输入内容"
          ></el-input
          ><span>人</span> <span> 加客费：</span
          ><el-input
            readonly
            v-model="hourseInfo.houseFavour.mCusPlusMoney"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <span>人/晚</span>
      </div>
    </div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">其他额外费用：</div>
        <div class="radio_boxs">
          <el-input
            readonly
            type="textarea"
            maxlength="2000 "
            resize="none"
            placeholder="对水费、电费、燃气费等其他费用有其他要求，请进行描述。（选填）"
            v-model="hourseInfo.houseFavour.mOtherMoney"
          >
          </el-input>
        </div>
      </div>
    </div>
    <!-- 优惠活动 -->
    <div class="information_title">优惠活动：</div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">开启新房促销：</div>
        <div class="radio_boxs">
          <div
            class="radio"
            style="width:750px"
            v-if="hourseInfo.houseFavour.iNewSale == 1"
          >
            <div
              class="radio_left_"
              v-if="hourseInfo.houseFavour.iNewSale == 1"
            >
              <div class="ischeck"></div>
            </div>
            <div class="radio_left" v-else></div>
            <div class="radio_right">
              <div class="radio_right_top">
                参与新房促销
              </div>
              <div class="radio_right_bottom">
                前3单入住的房客将享受8折促销。新房促销有助于提升您在众多房源中的竞争力，并增加房源的曝光度
              </div>
            </div>
          </div>
          <div
            class="radio "
            style="width:750px"
            v-if="hourseInfo.houseFavour.iNewSale == 0"
          >
            <div
              class="radio_left_"
              v-if="hourseInfo.houseFavour.iNewSale == 0"
            >
              <div class="ischeck"></div>
            </div>
            <div class="radio_left" v-else></div>
            <div class="radio_right">
              <div class="radio_right_top">
                不参与新房促销
              </div>
              <div class="radio_right_bottom">
                较其他新房源可能不具备有利的价格优势及足够的吸引力
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="information_siteBox"
      v-if="hourseInfo.houseFavour.iNewSale == 1"
    >
      <div class="information_site">
        <div class="information_site_left">优惠折扣：</div>
        <div class="radio_boxs">
          <el-input
            v-model="hourseInfo.houseFavour.mNewCount"
            placeholder="请输入内容"
            readonly
          ></el-input>
        </div>
        <span>折</span>
      </div>
    </div>
    <div v-if="hourseInfo.houseFavour.iLinkSale == 1">
      <div
        class="information_siteBox"
        v-for="(item, index) in hourseInfo.houseRuleLink"
        :key="index"
      >
        <div class="information_site">
          <div class="information_site_left">连住优惠：</div>
          <div class="radio_boxs">
            连续入住满
            <el-input
              readonly
              oninput="value=value.replace(/[^\d.]/g,'')"
              v-model.number="item.iLinkDays"
              placeholder="请输入内容"
            ></el-input>
            <span>天的房客享受</span>
            <el-input
              readonly
              oninput="value=value.replace(/[^\d.]/g,'')"
              v-model.number="item.iLinkCount"
              placeholder="请输入内容"
            ></el-input>
            <span>折折扣的房价</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="information_siteBox"
      v-if="hourseInfo.houseFavour.iNightSale == 1"
    >
      <div class="information_site">
        <div class="information_site_left">今夜特价：</div>
        <div class="radio_boxs">
          <div class="select_box">
            超过
            <el-input
              readonly
              oninput="value=value.replace(/[^\d.]/g,'')"
              v-model.number="hourseInfo.houseRuleNight[0].dNightStart"
              placeholder="请输入内容"
            ></el-input>

            未卖出，当日该房源将自动从8折开始将逐小时降价，最低降至
            <el-select
              v-model="hourseInfo.houseRuleNight[0].iNightCount"
              placeholder="请选择"
            >
              <el-option
                readonly
                v-for="item in optionsNightCount"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            折扣房价出售
          </div>
        </div>
      </div>
    </div>
    <!-- 预定规则 -->
    <div class="information_title">预定规则</div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">最少入住天数：</div>
        <div class="radio_boxs">
          <el-input
            readonly
            v-model="hourseInfo.houseFavour.iMiniDays"
            placeholder="请输入内容"
          ></el-input
          ><span>天</span>
          <span class="radio_boxs_span_left">最多入住天数：</span
          ><el-input
            readonly
            v-model="hourseInfo.houseFavour.iMaxDays"
            placeholder="0为不设限"
          ></el-input
          ><span>天（0为不设限）</span>
        </div>
      </div>
    </div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">当天预定时间：</div>
        <div class="radio_boxs">
          <el-select
            v-model="hourseInfo.houseFavour.params.iScheduledTime"
            placeholder="请选择"
            class="none_margin"
          >
            <el-option
              disabled
              v-for="item in optionsNightStart"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">入住时间：</div>
        <div class="radio_boxs">
          <el-select
            v-model="hourseInfo.houseFavour.params.iCheckStartTime"
            placeholder="请选择"
            class="none_margin"
          >
            <el-option
              disabled
              v-for="item in optionsNightStart"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span>至</span>
          <el-select
            v-model="hourseInfo.houseFavour.params.iCheckEndTime"
            placeholder="请选择"
            class="none_margin"
          >
            <el-option
              disabled
              v-for="item in optionsNightStart"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">退房时间：</div>
        <div class="radio_boxs">
          <el-select
            v-model="hourseInfo.houseFavour.params.iCheckOutTime"
            placeholder="请选择"
            class="none_margin"
          >
            <el-option
              v-for="item in optionsNightStart"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="information_siteBox">
      <div class="information_site">
        <div class="information_site_left">房客退订规则：</div>
        <div class="radio_boxs">
          <div
            class="radio"
            style="width:600px"
            v-if="hourseInfo.houseFavour.iCheckRule == 0"
          >
            <div
              class="radio_left_"
              v-if="hourseInfo.houseFavour.iCheckRule == 0"
            >
              <div class="ischeck"></div>
            </div>
            <div class="radio_left" v-else></div>
            <div class="radio_right">
              <div class="radio_right_top">
                宽松
              </div>
              <div class="radio_right_bottom">
                入住前一天12:00前退订，可获100%退款。之后退订不退款
              </div>
            </div>
          </div>
          <div
            class="radio "
            style="width:600px"
            v-if="hourseInfo.houseFavour.iCheckRule == 1"
          >
            <div
              class="radio_left_"
              v-if="hourseInfo.houseFavour.iCheckRule == 1"
            >
              <div class="ischeck"></div>
            </div>
            <div class="radio_left" v-else></div>
            <div class="radio_right">
              <div class="radio_right_top">
                适中
              </div>
              <div class="radio_right_bottom">
                入住前五天12:00前退订，可获100%退款。之后退订不退款
              </div>
            </div>
          </div>
          <div
            class="radio "
            style="width:600px"
            v-if="hourseInfo.houseFavour.iCheckRule == 2"
          >
            <div
              class="radio_left_"
              v-if="hourseInfo.houseFavour.iCheckRule == 2"
            >
              <div class="ischeck"></div>
            </div>
            <div class="radio_left" v-else></div>
            <div class="radio_right">
              <div class="radio_right_top">
                严格
              </div>
              <div class="radio_right_bottom">
                入住前七天12:00前退订，可获100%退款。之后退订不退款
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 上传房源资质 -->
    <div class="information_title">上传房源资质</div>
    <div class="information_siteBox">
      <div class="information_site">
        <!-- <div class="information_site_left">房源位于：</div> -->
        <div class="radio_boxs">
          <div class="qualification">
            <div class="qualification_left">证件类型</div>
          </div>
          <div class="qualification_checkbox_list">
            <!-------- 分割线 --------->
            <div class="checkbox_Box">
              <div class="qualification_checkbox">
                <div
                  class="qualification_checkbox_true"
                  v-if="hourseInfo.houseFavour.vDocumentType == 0"
                >
                  <div class="checkbox_true"></div>
                </div>
                <div class="qualification_checkbox_false" v-else></div>
              </div>
              <div class="qualification_text">
                营业执照
              </div>
            </div>
            <!-------- 分割线 --------->
            <div class="checkbox_Box">
              <div class="qualification_checkbox">
                <div
                  class="qualification_checkbox_true"
                  v-if="hourseInfo.houseFavour.vDocumentType == 1"
                >
                  <div class="checkbox_true"></div>
                </div>
                <div class="qualification_checkbox_false" v-else></div>
              </div>
              <div class="qualification_text">
                房产证
              </div>
            </div>
            <!-------- 分割线 --------->
            <div class="checkbox_Box">
              <div class="qualification_checkbox">
                <div
                  class="qualification_checkbox_true"
                  v-if="hourseInfo.houseFavour.vDocumentType == 2"
                >
                  <div class="checkbox_true"></div>
                </div>
                <div class="qualification_checkbox_false" v-else></div>
              </div>
              <div class="qualification_text">
                租赁合同
              </div>
            </div>
            <!-------- 分割线 --------->
            <div class="checkbox_Box">
              <div class="qualification_checkbox">
                <div
                  class="qualification_checkbox_true"
                  v-if="hourseInfo.houseFavour.vDocumentType == 3"
                >
                  <div class="checkbox_true"></div>
                </div>
                <div class="qualification_checkbox_false" v-else></div>
              </div>
              <div class="qualification_text">
                其他证件
              </div>
            </div>
            <br />
            <!-------- 分割线 --------->
            <div class="checkbox_Box">
              <div class="qualification_checkbox">
                <div
                  class="qualification_checkbox_true"
                  v-if="hourseInfo.houseFavour.vDocumentType == 4"
                >
                  <div class="checkbox_true"></div>
                </div>
                <div class="qualification_checkbox_false" v-else></div>
              </div>
              <div class="qualification_text">
                特种行业许可证
              </div>
            </div>
            <!-------- 分割线 --------->
            <div class="checkbox_Box">
              <div class="qualification_checkbox">
                <div
                  class="qualification_checkbox_true"
                  v-if="hourseInfo.houseFavour.vDocumentType == 5"
                >
                  <div class="checkbox_true"></div>
                </div>
                <div class="qualification_checkbox_false" v-else></div>
              </div>
              <div class="qualification_text">
                消防许可证
              </div>
            </div>
            <!-------- 分割线 --------->
            <div class="checkbox_Box">
              <div class="qualification_checkbox">
                <div
                  class="qualification_checkbox_true"
                  v-if="hourseInfo.houseFavour.vDocumentType == 6"
                >
                  <div class="checkbox_true"></div>
                </div>
                <div class="qualification_checkbox_false" v-else></div>
              </div>
              <div class="qualification_text">
                卫生许可证
              </div>
            </div>
            <!-------- 分割线 --------->
            <div class="checkbox_Box">
              <div class="qualification_checkbox">
                <div
                  class="qualification_checkbox_true"
                  v-if="hourseInfo.houseFavour.vDocumentType == 7"
                >
                  <div class="checkbox_true"></div>
                </div>
                <div class="qualification_checkbox_false" v-else></div>
              </div>
              <div class="qualification_text">
                租赁房屋治安责任保证书
              </div>
            </div>
          </div>
          <div class="picture_box">
            <div class="picture_box_bottom">
              <div class="picture_upload">
                <el-image
                  style="width: 120px; height: 120px"
                  :src="hourseInfo.houseFavour.vDocumentPic"
                  :preview-src-list="srcList"
                  @click="getImg(hourseInfo.houseFavour.vDocumentPic)"
                >
                </el-image>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="next_Btn">
      <el-button class="affirm" @click="next_Btn">房源预览/房源详情</el-button>
      <el-button
        v-if="hourseInfo.iHourseStatus !== 2"
        class="preview"
        @click="dialogVisible = true"
        >审核</el-button
      >
    </div>
    <!-- 审核标签弹出框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="1280px"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="90px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="装修程度"
          prop="houseIntegral.iDecorationStatus"
          :rules="{
            required: true,
            message: '装修程度不能为空',
            trigger: 'change'
          }"
        >
          <el-select
            v-model="ruleForm.houseIntegral.iDecorationStatus"
            placeholder="请选择装修程度"
          >
            <el-option
              v-for="item in DecorationDegree"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="装修风格">
          <el-select
            v-model="ruleForm.houseIntegral.vDecorationStyle"
            placeholder="请选择装修风格"
          >
            <el-option label="无特色风格" value=""></el-option>
            <el-option
              v-for="item in DecorationStyle"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐标签">
          <div class="PlatformRecommend_box">
            <el-checkbox-group
              v-model="ruleForm.houseIntegral.vRecommendLabels"
              size="small"
            >
              <el-checkbox-button
                v-for="city in PlatformRecommend"
                :label="city.value"
                :key="city.value"
                >{{ city.label }}</el-checkbox-button
              >
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="位置标签">
          <div class="LocationLabel_box">
            <div class="LocationLabel_box_top">
              <el-checkbox-group
                v-model="ruleForm.houseIntegral.vLocationLabels"
                size="small"
              >
                <el-checkbox-button
                  v-for="city in LocationLabel"
                  :label="city.value"
                  :key="city.value"
                  >{{ city.label }}</el-checkbox-button
                >
              </el-checkbox-group>
            </div>
            <div class="LocationLabel_box_bottom" v-if="LocationLabelList">
              <!-- 地铁 -->
              <div class="bottom_box" v-if="LocationLabelList.trafficList">
                <div class="bottom_left">附近地铁：</div>
                <div class="bottom_right">
                  <div
                    class="right_box"
                    v-for="item in LocationLabelList.trafficList"
                    :key="item.id"
                    @click="ChangeBtn(item)"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.place + item.distance + 'km'"
                      placement="top-start"
                    >
                      <div class="bottom_right_box">
                        {{ item.place }}{{ item.distance }}km
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <!-- 附近商圈： -->
              <div class="bottom_box" v-if="LocationLabelList.businessList">
                <div class="bottom_left">附近商圈：</div>
                <div class="bottom_right">
                  <div
                    class="right_box"
                    v-for="item in LocationLabelList.businessList"
                    :key="item.id"
                    @click="ChangeBtn(item)"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.place + item.distance + 'km'"
                      placement="top-start"
                    >
                      <div class="bottom_right_box">
                        {{ item.place }}{{ item.distance }}km
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <!-- 附近景区： -->
              <div class="bottom_box" v-if="LocationLabelList.placeList">
                <div class="bottom_left">附近景区：</div>
                <div class="bottom_right">
                  <div
                    class="right_box"
                    v-for="item in LocationLabelList.placeList"
                    :key="item.id"
                    @click="ChangeBtn(item)"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.place + item.distance + 'km'"
                      placement="top-start"
                    >
                      <div class="bottom_right_box">
                        {{ item.place }}{{ item.distance }}km
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <!-- 附近高校： -->
              <div class="bottom_box" v-if="LocationLabelList.highSchoolList">
                <div class="bottom_left">附近高校：</div>
                <div class="bottom_right">
                  <div
                    class="right_box"
                    v-for="item in LocationLabelList.highSchoolList"
                    :key="item.id"
                    @click="ChangeBtn(item)"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.place + item.distance + 'km'"
                      placement="top-start"
                    >
                      <div class="bottom_right_box">
                        {{ item.place }}{{ item.distance }}km
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <!-- 附近飞机场： -->
              <div class="bottom_box" v-if="LocationLabelList.airList">
                <div class="bottom_left">近飞机场：</div>
                <div class="bottom_right">
                  <div
                    class="right_box"
                    v-for="item in LocationLabelList.airList"
                    :key="item.id"
                    @click="ChangeBtn(item)"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.place + item.distance + 'km'"
                      placement="top-start"
                    >
                      <div class="bottom_right_box">
                        {{ item.place }}{{ item.distance }}km
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <!-- 附近火车站： -->
              <div class="bottom_box" v-if="LocationLabelList.trainList">
                <div class="bottom_left">近火车站：</div>
                <div class="bottom_right">
                  <div
                    class="right_box"
                    v-for="item in LocationLabelList.trainList"
                    :key="item.id"
                    @click="ChangeBtn(item)"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.place + item.distance + 'km'"
                      placement="top-start"
                    >
                      <div class="bottom_right_box">
                        {{ item.place }}{{ item.distance }}km
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <!-- 附近医院： -->
              <!-- <div class="bottom_box">
                <div class="bottom_left">附近医院：</div>
                <div class="bottom_right">
                  <div
                    class="right_box"
                    v-for="item in LocationLabelList.trainList"
                    :key="item.id"
                    @click="ChangeBtn(item)"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.place + item.distance + 'km'"
                      placement="top-start"
                    >
                      <div class="bottom_right_box">
                        {{ item.place }}{{ item.distance }}km
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <div
            class="radio_yes"
            @click="ruleForm.hourseQuery.iHourseStatus = 2"
          >
            <div
              class="radio_yes_left_s"
              v-if="ruleForm.hourseQuery.iHourseStatus == 2"
            >
              <div class="radio_box"></div>
            </div>
            <div class="radio_yes_left" v-else></div>
            <div class="radio_yes_right">立即上线</div>
          </div>
          <div class="radio_no" @click="ruleForm.hourseQuery.iHourseStatus = 4">
            <div
              class="radio_no_left_s"
              v-if="ruleForm.hourseQuery.iHourseStatus == 4"
            >
              <div class="radio_box"></div>
            </div>
            <div class="radio_no_left" v-else></div>
            <div class="radio_no_right">拒接上线</div>
          </div>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.hourseQuery.iHourseStatus == 4"
          prop="hourseQuery.cExamineDes"
          :rules="{
            required: true,
            message: '拒绝理由不能为空',
            trigger: 'blur'
          }"
        >
          <el-input
            type="textarea"
            resize="none"
            placeholder="请填写拒绝理由..."
            v-model="ruleForm.hourseQuery.cExamineDes"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel('ruleForm')" class="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm('ruleForm')" class="confirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改标签 -->
    <el-dialog
      title="编辑"
      :visible.sync="dialogVisibleChange"
      width="750px"
      :before-close="handleClose"
    >
      <el-form
        :model="Form"
        :rules="rules"
        ref="Form"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="类型">
          <el-input v-model="Form.type" disabled></el-input>
        </el-form-item>
        <el-form-item label="简称" prop="name">
          <el-input v-model="Form.abbreviation"></el-input>
        </el-form-item>
        <el-form-item label="全称">
          <el-input v-model="Form.fllName" disabled></el-input>
        </el-form-item>
        <el-form-item label="ID">
          <el-input v-model="Form.mapLandmarkId" disabled></el-input>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="Form.address" disabled></el-input>
        </el-form-item>
        <el-form-item label="经纬度">
          <el-input v-model="Form.longitude" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="Form.remarks" class="remarks"></el-input>
        </el-form-item>
        <el-form-item label="显示状态">
          <div class="radio_yes" @click="Form.display = 1">
            <div class="radio_yes_left_s" v-if="Form.display == 1">
              <div class="radio_box"></div>
            </div>
            <div class="radio_yes_left" v-else></div>
            <div class="radio_yes_right">显示</div>
          </div>
          <div class="radio_no" @click="Form.display = 0">
            <div class="radio_no_left_s" v-if="Form.display == 0">
              <div class="radio_box"></div>
            </div>
            <div class="radio_no_left" v-else></div>
            <div class="radio_no_right">不显示</div>
          </div>
        </el-form-item>
        <el-form-item label="是否设为热门">
          <div class="radio_yes" @click="Form.hotspot = 1">
            <div class="radio_yes_left_s" v-if="Form.hotspot == 1">
              <div class="radio_box"></div>
            </div>
            <div class="radio_yes_left" v-else></div>
            <div class="radio_yes_right">是</div>
          </div>
          <div class="radio_no" @click="Form.hotspot = 0">
            <div class="radio_no_left_s" v-if="Form.hotspot == 0">
              <div class="radio_box"></div>
            </div>
            <div class="radio_no_left" v-else></div>
            <div class="radio_no_right">否</div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="dialogVisibleChange = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          class="confirm"
          @click="dialogVisibleChange = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  hourseAuditList,
  houseConfigList,
  examineLabel,
  examineChange
} from "../../api/index";
export default {
  data() {
    return {
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" }
        ]
      },
      srcList: [],
      // 房源类型
      houseType: [],

      optionsNightCount: [
        {
          value: "7.5",
          label: "7.5折"
        },
        {
          value: "7",
          label: "7折"
        },
        {
          value: "6.5",
          label: "6.5折"
        },
        {
          value: "6",
          label: "6折"
        },
        {
          value: "5.5",
          label: "5.5折"
        },
        {
          value: "5",
          label: "5折"
        },
        {
          value: "4.5",
          label: "4.5折"
        },
        {
          value: "4",
          label: "4折"
        },
        {
          value: "3.5",
          label: "3.5折"
        },
        {
          value: "3",
          label: "3折"
        },
        {
          value: "2.5",
          label: "2.5折"
        },
        {
          value: "2",
          label: "2折"
        },
        {
          value: "1.5",
          label: "1.5折"
        },
        {
          value: "1",
          label: "1折"
        }
      ],
      optionsNightStart: [
        {
          value: "1",
          label: "1点"
        },
        {
          value: "2",
          label: "2点"
        },
        {
          value: "3",
          label: "3点"
        },
        {
          value: "4",
          label: "4点"
        },
        {
          value: "5",
          label: "5点"
        },
        {
          value: "6",
          label: "6点"
        },
        {
          value: "7",
          label: "7点"
        },
        {
          value: "8",
          label: "8点"
        },
        {
          value: "9",
          label: "9点"
        },
        {
          value: "10",
          label: "10点"
        },
        {
          value: "11",
          label: "11点"
        },
        {
          value: "12",
          label: "12点"
        },
        {
          value: "13",
          label: "13点"
        },
        {
          value: "14",
          label: "14点"
        },
        {
          value: "15",
          label: "15点"
        },
        {
          value: "16",
          label: "16点"
        },
        {
          value: "17",
          label: "17点"
        },
        {
          value: "18",
          label: "18点"
        },
        {
          value: "19",
          label: "19点"
        },
        {
          value: "20",
          label: "20点"
        },
        {
          value: "21",
          label: "21点"
        },
        {
          value: "22",
          label: "22点"
        },
        {
          value: "23",
          label: "23点"
        },
        {
          value: "24",
          label: "24点"
        }
      ],
      options: [],

      // 新建地址弹出层
      dialogVisible: false,
      dialogVisibleChange: false,
      // ---------------------分割线-----------------------
      activeName: "site",
      recommend: [], //选中的标签
      DecorationDegree: [], //装修程度
      LocationLabel: [], //位置标签
      LocationLabelList: [], //位置标签详情
      DecorationStyle: [], //装修风格
      PlatformRecommend: [], //推荐标签
      houseId: "",
      houseTypeList: null,
      CheckInNotes: [],
        hourseInfo: {
          houseInfoSon:{

          },
            houseFavour:{
                params:{

                }
            }
      },
      serviceList: [],
      demand: [],
      ruleForm: {
        houseId: "",
        hourseQuery: {
          iHourseStatus: 4,
          cExamineDes: ""
        },
        houseIntegral: {
          iDecorationStatus: "", //装修程度
          vDecorationStyle: "", //装修风格
          vRecommendLabels: [], //推荐标签
          vLocationLabels: [] //位置标签
        }
      },
      Form: {
        type: "",
        abbreviation: "",
        fllName: "",
        mapLandmarkId: "",
        address: "",
        longitude: "",
        remarks: "",
        display: 1,
        hotspot: 1
      }
    };
  },
  created() {
    window.sessionStorage.setItem("houseId", this.$route.params.houseId);
    console.log(window.sessionStorage.getItem("houseId"));
    this.houseId = window.sessionStorage.getItem("houseId") || "";
    this.ruleForm.houseId = window.sessionStorage.getItem("houseId") || "";
    this.hourseAuditListGet();
    this.houseConfigListAjax();
    this.examineLabelAjax();
    console.log(this.houseId);
  },
  methods: {
    // 查看图片
    getImg(e) {
      this.srcList = [];
      this.srcList.push(e);
    },
    async houseConfigListAjax() {
      const { data: res } = await houseConfigList();
      this.houseType = res.data.houseKind[0].children;
      this.options = res.data.bedInfo[0].children.map(item => {
        var children = [];
        if (item.children !== []) {
          children = item.children.map(item => {
            return { value: item.iConfigId, label: item.vMenuName };
          });
        }
        return { value: item.iConfigId, label: item.vMenuName, children };
      });
    },

    async hourseAuditListGet() {
      try {
        const { data: res } = await hourseAuditList(this.houseId);
        if (res.code !== 200)
          return this.$message({
            message: res.msg,
            type: "error"
          });
        this.houseTypeList =parseInt( res.data.hourseInfo.property||'212')
        this.CheckInNotes = res.data.CheckInNotes;
          res.data.hourseInfo.houseBedInfo.forEach(item=>{
              if(item.vBedStyle.split(",").length>=2){
                  item.vBedStyles=item.vBedStyle.split(",").map(item=>parseInt(item))
              }

          })
        this.hourseInfo = res.data.hourseInfo;
          console.log(res.data.hourseInfo)
        this.serviceList = res.data.serviceList[0] == null?res.data.serviceList: res.data.serviceList[0];
        this.demand = res.data.hourseInfo.params.configList;
      } catch (error) {
        console.log(error);
      }
    },
    async examineLabelAjax() {
      const { data: res } = await examineLabel(this.houseId);
      this.DecorationStyle = res.data.DecorationStyle.children;
      this.LocationLabel = res.data.LocationLabel.children;
      this.LocationLabelList = res.data.LocationLabelList;
      this.PlatformRecommend = res.data.PlatformRecommend.children;
      this.DecorationDegree = res.data.DecorationDegree.children;
    },
    cancel(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.ruleForm = {
        houseId: window.sessionStorage.getItem("houseId") || "",
        hourseQuery: {
          iHourseStatus: 4,
          cExamineDes: ""
        },
        houseIntegral: {
          iDecorationStatus: "", //装修程度
          vDecorationStyle: "", //装修风格
          vRecommendLabels: [], //推荐标签
          vLocationLabels: [] //位置标签
        }
      };
    },
    confirm(formName) {
      if (this.ruleForm.houseIntegral.iDecorationStatus == 360) {
        this.ruleForm.houseIntegral.iDecorationStatus = -1;
      }
      if (this.ruleForm.houseIntegral.iDecorationStatus == 361) {
        this.ruleForm.houseIntegral.iDecorationStatus = 0;
      }
      if (this.ruleForm.houseIntegral.iDecorationStatus == 243) {
        this.ruleForm.houseIntegral.iDecorationStatus = 2;
      }
      if (this.ruleForm.houseIntegral.iDecorationStatus == 244) {
        this.ruleForm.houseIntegral.iDecorationStatus = 4;
      }

      this.$refs[formName].validate(async valid => {
        if (valid) {
          const { data: res } = await examineChange(this.ruleForm);
          if (res.code !== 200)
            return this.$message({
              type: "error",
              message: res.msg
            });
          this.ruleForm = {
            houseId: window.sessionStorage.getItem("houseId") || "",
            hourseQuery: {
              iHourseStatus: 4,
              cExamineDes: ""
            },
            houseIntegral: {
              iDecorationStatus: "", //装修程度
              vDecorationStyle: "", //装修风格
              vRecommendLabels: [], //推荐标签
              vLocationLabels: [] //位置标签
            }
          };
          this.$router.push({
            name: "HousingAuditList" //跳转的路径
          });
          this.dialogVisible = false;
          return this.$message({
            type: "success",
            message: res.msg
          });
        } else {
          return false;
        }
      });
    },
    ChangeBtn(item) {
      this.dialogVisibleChange = true;
      console.log(item);
    },
    next_Btn() {
      this.$router.push({
        name: "productDetails", //跳转的路径
        query: {
          customerId: this.houseId
        }
      });
    },
    handleClose(done) {
      done();
    },
    handleClick(tab, event) {
      window.document.getElementById(`${tab.name}`).scrollIntoView({
        behavior: "smooth",
        block: "start",
        alignTo: "true",
        inline: "start"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.information_title {
  height: 66px;
  line-height: 66px;
  margin-top: 30px;
  color: #f6b439;
  font-size: 20px;
  border-bottom: 1px solid #e1e1e1;
}
.information_siteBox {
  overflow: hidden;
  margin-top: 20px;
  .information_site {
    float: left;
    margin-left: 36px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    span {
      display: inline-block;
      line-height: 50px;
      margin-left: 10px;
      margin-right: 10px;
    }
    .information_site_left {
      width: 130px;
      float: left;
      line-height: 50px;
    }
    .radio_boxs {
      float: left;
      .radio_boxs_span_left {
        margin-left: 60px;
      }
    }
    .information_site_right {
      line-height: 50px;
      padding-left: 12px;
      float: left;
      // margin-left: 10px;
      height: 50px;
      width: 860px;
      background-color: #f2f2f2;
      border-radius: 4px;
    }
  }
}
.information_siteBox:nth-last-of-type(1) {
  margin-bottom: 200px;
}

.radio {
  cursor: pointer;
  margin-bottom: 20px;
  width: 500px;
  height: 84px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  .radio_left {
    float: left;
    margin: 30px 25px;
    border-radius: 50%;
    border: 1px solid #e1e1e1;
    width: 24px;
    height: 24px;
  }
  .radio_right {
    overflow: hidden;
    float: left;
    height: 69px;
    margin-top: 15px;
  }
  .radio_right_top {
    font-size: 18px;
    line-height: 24px;
  }
  .radio_right_bottom {
    height: 18px;
    margin-top: 12px;
    font-size: 14px;
    line-height: 18px;
    color: #666666;
  }
}
.radio:nth-child(1) {
  margin-top: 10px;
}
.radio_left_ {
  float: left;
  margin: 30px 25px;
  border-radius: 50%;
  border: 1px solid #f6b439;
  width: 24px;
  height: 24px;
  .ischeck {
    margin: 6px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: #f6b439;
  }
}
.radio_bottom {
  .radio_bottom_text {
    line-height: 50px;
    float: left;
  }
  height: 50px;
  .radio_yes {
    width: 58px;
    line-height: 50px;
    float: left;
    margin-left: 72px;
    .radio_yes_left {
      margin: 12px 15px 0 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid #dcdcdc;
      float: left;
    }
    .radio_yes_left {
      float: left;
    }
  }
  .radio_no {
    width: 58px;
    line-height: 50px;
    float: left;
    margin-left: 100px;
    .radio_no_left {
      margin: 12px 15px 0 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid #dcdcdc;
      float: left;
    }
    .radio_no_left {
      float: left;
    }
  }
}
.radio_yes_left_s {
  margin: 5px 15px 0 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #f6b439;
  float: left;
}
.radio_no_left_s {
  margin: 5px 15px 0 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #f6b439;
  float: left;
}
.radio_box {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 6px;
  background-color: #f6b439;
}
.acreage {
  margin-bottom: 20px;
  height: 50px;
  line-height: 50px;
  .el-select {
    margin: 0 20px 20px 0;
  }
  .el-select:nth-child(3) {
    margin: 0 10px 20px 0;
  }
}
.picture_box {
  margin: 25px 36px;
  height: 214px;
  .picture_box_top {
    font-size: 18px;
    span {
      color: #666666;
    }
    .text {
      display: inline;
      color: #f6b439;
    }
  }
}
.picture_box_bottom {
  margin-top: 20px;
  height: 140px;
  .picture_upload {
    float: left;
    margin-right: 20px;

    height: 120px;
    // width: 120px;
  }
}
.radio_yes {
  // width: 100px;
  line-height: 50px;
  float: left;
  // margin-left: 72px;
  margin-right: 100px;
  .radio_yes_left {
    margin: 12px 15px 0 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #dcdcdc;
    float: left;
  }
  .radio_yes_right {
    float: left;
    font-size: 18px;
  }
}
.radio_text {
  float: left;
  margin-left: -80px;
  line-height: 50px;
  color: #666666;
  font-size: 14px;
}
.radio_yes_left_s {
  margin: 12px 15px 0 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #f6b439;
  float: left;
}
.radio_no_left_s {
  margin: 12px 15px 0 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #f6b439;
  float: left;
}
.form_item {
  overflow: hidden;
  height: 50px;
  .form_item_title {
    float: left;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    margin: 5px 142px 20px 0px;
    color: #666666;
    span {
      color: #f6b439;
    }
  }
  .form_item_title:nth-child(2) {
    margin-right: 170px;
  }
}
.iDepositRule {
  height: 50px;
}
.radio_no {
  line-height: 40px;
  float: left;
  // margin-left: 100px;
  margin-right: 100px;
  .radio_no_left {
    margin: 12px 15px 0 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #dcdcdc;
    float: left;
  }
  .radio_no_right {
    float: left;
    line-height: 45px;
    font-size: 18px;
  }
}
.checkbox_Box {
  width: 255px;
  height: 64px;
  float: left;
  cursor: pointer;
}
.qualification_checkbox_list {
  overflow: hidden;
  width: 1200px;
  font-size: 18px;
  // margin-left: 34px;
}
.qualification_checkbox {
  float: left;

  width: 32px;
  height: 64px;
  .qualification_checkbox_false {
    float: left;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #dcdcdc;
  }
  .qualification_checkbox_true {
    float: left;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #f6b439;
    .checkbox_true {
      height: 10px;
      width: 10px;
      margin: 6px;
      background-color: #f6b439;
      border-radius: 50%;
    }
  }
}
.qualification {
  overflow: hidden;
  vertical-align: middle;
  font-size: 18px;
  // margin-left: 34px;
  .qualification_left {
    height: 50px;
    float: left;
  }
}
.next_Btn {
  height: 64px;
  margin-bottom: 100px;
  .affirm {
    width: 250px;
    height: 64px;
    padding: 0;
    font-size: 24px;
    color: #fff;
    background-color: #f6b439;
  }
  .preview {
    width: 180px;
    height: 64px;
    font-size: 24px;
    color: #fff;
    background-color: #2f80ed;
    margin-left: 50px;
  }
}
/deep/.el-select {
  height: 50px;
  width: 160px;
  .el-input {
    height: 50px;
    width: 160px;
    .el-input__inner {
      height: 50px;
      width: 160px;
    }
  }
}
/deep/.el-input {
  height: 50px;
  width: 160px;
  .el-input__inner {
    height: 50px;
    width: 160px;
  }
}
/deep/.el-textarea__inner {
  width: 958px;
  height: 300px;
}
/deep/.el-textarea {
  width: 950px;
}
.input_title {
  width: 950px;
  height: 150px;
  /deep/.el-textarea__inner {
    width: 958px;
    height: 150px;
  }
}

/deep/.el-cascader {
  height: 50px;
  width: 434px;
}
/deep/ .el-cascader .el-input {
  height: 50px;
  width: 400px;
  margin-right: 20px;
  .el-input__inner {
    height: 50px;
    width: 100%;
  }
}
.select_box {
  height: 52px;
  margin-bottom: 20px;
}
.facility_list {
  position: relative;
  min-height: 128px;
  padding: 1px;
  overflow: hidden;
  .facility_list_left {
    position: absolute;
    left: 0;
    top: 18px;
    // transform: translateY(-50%);
    width: 60px;
    .img {
      width: 60px;

      // position: absolute;
      // top: 50%;
      // left: 50%;
      // trasnsform: translate(-50%, -50%);
      // img {
      //   width: 60px;
      //   height: 60px;
      // }
      .img_text {
        margin-top: 5px;
        text-align: center;
        font-size: 18px;
      }
    }
  }
  .facility_list_right {
    margin-left: 110px;
    margin-top: 20px;
    float: left;
    .facility_list_rightList_box {
      float: left;

      .facility_list_rightList {
        float: left;
        width: 225px;
        height: 64px;
        .rightList_left {
          float: left;
          width: 24px;
          height: 24px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .rightList_right {
          float: left;
          margin-left: 15px;
          font-size: 18px;
          color: #333333;
        }
      }
    }
  }
}
.notice_Box {
  overflow: hidden;
  padding: 30px 0 0 0;
}

.notice {
  width: 608px;
  height: 54px;
  .notice_left {
    float: left;
    line-height: 54px;
    font-size: 18px;
  }
  .notice_right {
    margin-top: 5px;
    float: right;
  }
}
/deep/.el-dialog {
  padding: 0 48px;
}
/deep/.el-dialog__header {
  padding: 26px;
}
/deep/.el-dialog__body {
  padding: 0;
  // padding: 48px;
  .LocationLabel_box {
    padding: 20px;
    width: 100%;
    min-height: 390px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    .LocationLabel_box_top {
      width: 100%;
      height: 60px;
      border-bottom: 1px solid #e1e1e1;
    }
    .LocationLabel_box_bottom {
      padding: 15px 0 0 0;
      .bottom_box {
        overflow: hidden;
        width: 100%;
        .bottom_left {
          float: left;
          width: 70px;
          height: 30px;
          line-height: 30px;
        }
        .bottom_right {
          width: 980px;
          float: left;
          // margin-left: 90px;
          min-height: 30px;
          .right_box {
            width: 180px;
            height: 30px;
            float: left;
            margin-right: 15px;
            margin-bottom: 15px;
            .bottom_right_box {
              cursor: pointer;

              width: 180px;
              height: 30px;
              background-color: #f2f2f2;
              border-radius: 4px;
              line-height: 30px;

              padding: 0 9px;
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .bottom_right_box:hover {
              background: rgba(246, 180, 57, 0.3);
            }
          }

          .right_box:nth-child(5n) {
            margin-right: 0px;
          }
        }
      }
      .bottom_box:nth-last-child(1) {
        margin: 0;
      }
    }
  }
  .PlatformRecommend_box {
    line-height: 60px;
    padding-left: 20px;
    height: 60px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
  }
}

/deep/.el-dialog__footer {
  padding: 40px 48px;
  .cancel {
    width: 72px;
    height: 36px;
    background: #f2f2f2;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    margin-right: 24px;
  }
  .confirm {
    margin-left: 0;
    width: 72px;
    height: 36px;
    background: #f6b439;
    border: 1px solid #f6b439;
    border-radius: 4px;
  }
}

/deep/.el-form-item__content {
  .radio_yes {
    height: 36px;
    line-height: 36px;
    .radio_yes_left_s {
      margin-top: 7px;
    }
    .radio_no_left_s {
      margin-top: 7px;
    }
    .radio_yes_left {
      margin-top: 7px;
    }
  }
  .radio_no {
    height: 36px;
    line-height: 36px;
    .radio_yes_left_s {
      margin-top: 7px;
    }
    .radio_no_left {
      margin-top: 7px;
    }
    .radio_no_right {
      height: 36px;
      line-height: 36px;
    }
    .radio_no_left_s {
      margin-top: 7px;
    }
  }
  .el-textarea {
    width: 1094px;
    height: 204px;
    .el-textarea__inner {
      background-color: #f6f6f6;
      width: 1094px;
      height: 204px;
    }
  }
  .el-input {
    width: 100%;
    height: 36px;
    .el-input__inner {
      width: 100%;
      height: 36px;
    }
  }
  .el-select {
    width: 100%;
    height: 42px;
    .el-input {
      width: 100%;
      height: 42px;
    }
    .el-input__inner {
      width: 100%;
      height: 42px;
    }
  }
  .remarks {
    width: 100%;
    height: 125px;
    .el-input__inner {
      width: 100%;
      height: 125px;
    }
  }
}
.tabs {
  background-color: #fff;
  position: fixed;
  width: 90%;
  padding-top: 46px;
  height: 100px;
  top: 118px;
  left: 224px;
  z-index: 2000;
}
.el-main {
  position: relative;
  // padding-top: 50px !important;
}
/deep/.el-tabs__active-bar {
  background-color: #f6b439;
}
/deep/.el-tabs__item.is-active {
  color: #f6b439;
  font-size: 18px;
}
/deep/.el-tabs__item:hover {
  color: #f6b439;
}
/deep/.el-tabs__item {
  font-size: 18px;
}
.tabs_bottom {
  margin-top: 100px;
}
</style>
